// Fisher-Yates shuffle of a copy of `items`
export function shuffled(items, rng = Math.random) {
  const copy = [...items];
  for (let i = copy.length - 1; i > 0; i--) {
    const j = Math.floor(rng() * (i + 1));
    [copy[i], copy[j]] = [copy[j], copy[i]];
  }
  return copy;
}

// `count` distinct random items (all of them, shuffled, if there are fewer)
export function pickRandom(items, count, rng = Math.random) {
  return shuffled(items, rng).slice(0, count);
}

// a random index other than `index` (the same index when there is nothing else to pick)
export function randomOther(index, count, rng = Math.random) {
  if (count < 2) return index;
  const pick = Math.floor(rng() * (count - 1));
  return pick >= index ? pick + 1 : pick;
}
